import React, { useState } from 'react';
import Navbar from '../../components/Navbar';
import API from '../../utils/api';
import toast from 'react-hot-toast';
import { useAuth } from '../../context/AuthContext';

export default function AdminCredentials() {
  const { user } = useAuth();
  const [form, setForm] = useState({ current_password: '', new_phone: '', new_name: '', new_password: '', confirm_password: '' });
  const [saving, setSaving] = useState(false);
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async e => {
    e.preventDefault();
    if (!form.current_password) return toast.error('Current password is required');
    if (form.new_password && form.new_password !== form.confirm_password) return toast.error('New passwords do not match');
    if (form.new_password && form.new_password.length < 6) return toast.error('New password must be at least 6 characters');
    setSaving(true);
    try {
      const r = await API.put('/auth/admin-credentials', {
        current_password: form.current_password,
        new_phone: form.new_phone || undefined,
        new_name: form.new_name || undefined,
        new_password: form.new_password || undefined,
      });
      toast.success('✅ Credentials updated! Please login again.');
      setTimeout(() => { localStorage.removeItem('token'); window.location.replace('/#/admin-login'); }, 1500);
    } catch (err) { toast.error(err.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <Navbar />
      <div style={{ maxWidth: 560, margin: '0 auto', padding: '32px 20px' }}>
        <div className="page-header">
          <h1>🔑 Admin Credentials</h1>
          <p>Change your admin phone, name or password</p>
        </div>

        <div className="alert alert-info" style={{ marginBottom: 24 }}>
          <strong>Current admin phone:</strong> {user?.phone} &nbsp;|&nbsp; <strong>Name:</strong> {user?.full_name}
        </div>

        <div className="card">
          <form onSubmit={handleSubmit}>
            {/* Current password - always required */}
            <div className="form-group">
              <label>Current Password * (required to make any changes)</label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showCurrent ? 'text' : 'password'}
                  value={form.current_password}
                  onChange={e => set('current_password', e.target.value)}
                  placeholder="Enter current password"
                  required
                  style={{ paddingRight: 44 }}
                />
                <button type="button" onClick={() => setShowCurrent(v => !v)} style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:'var(--text2)', fontSize:18 }}>
                  {showCurrent ? '🙈' : '👁️'}
                </button>
              </div>
            </div>

            <hr className="divider" />
            <p style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 16 }}>Leave fields blank to keep them unchanged</p>

            <div className="form-group">
              <label>New Phone Number (login ID)</label>
              <input type="tel" value={form.new_phone} onChange={e => set('new_phone', e.target.value)} placeholder={`Current: ${user?.phone}`} />
            </div>

            <div className="form-group">
              <label>New Display Name</label>
              <input value={form.new_name} onChange={e => set('new_name', e.target.value)} placeholder={`Current: ${user?.full_name}`} />
            </div>

            <div className="form-group">
              <label>New Password</label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showNew ? 'text' : 'password'}
                  value={form.new_password}
                  onChange={e => set('new_password', e.target.value)}
                  placeholder="Enter new password (min 6 chars)"
                  style={{ paddingRight: 44 }}
                />
                <button type="button" onClick={() => setShowNew(v => !v)} style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:'var(--text2)', fontSize:18 }}>
                  {showNew ? '🙈' : '👁️'}
                </button>
              </div>
            </div>

            {form.new_password && (
              <div className="form-group">
                <label>Confirm New Password</label>
                <input type="password" value={form.confirm_password} onChange={e => set('confirm_password', e.target.value)} placeholder="Confirm new password" />
              </div>
            )}

            <div className="alert alert-warning" style={{ marginBottom: 16, fontSize: 13 }}>
              ⚠️ After saving, you will be logged out and need to login with your new credentials.
            </div>

            <button type="submit" className="btn btn-primary btn-full btn-lg" disabled={saving}>
              {saving ? '⏳ Saving...' : '💾 Update Credentials'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
